module.exports = __webpack_public_path__ + "img/facebook-reactions-mobile.f590ec8c.svg";